import {UnrealUIContextProps} from './componentContext';

export const starfleetDefaultUIContext: UnrealUIContextProps = {
    RouteComponent: 'a',
    router: {
        push: () => {
            console.log('starfleetDefaultUIContext.router() push');
        }
    }
};
